import { render, staticRenderFns } from "./InputTextButton.vue?vue&type=template&id=39484871&scoped=true"
import script from "./InputTextButton.vue?vue&type=script&lang=js"
export * from "./InputTextButton.vue?vue&type=script&lang=js"
import style0 from "./InputTextButton.vue?vue&type=style&index=0&id=39484871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39484871",
  null
  
)

export default component.exports